import { ComponentProps, FC } from "react";
// eslint-disable-next-line drops/no-direct-spor-import
import { MenuCheckboxItem } from "@vygruppen/spor-react";
import styled from "styled-components";

type MenuCheckboxItemProps = ComponentProps<typeof MenuCheckboxItem>;

const StyledMenuCheckboxItem = styled(MenuCheckboxItem)`
  &&& {
    cursor: pointer;
  }
  > * {
    cursor: pointer;
  }

  div {
    outline: none;
  }
`;
export const InternalDropsMenuCheckboxItem: FC<MenuCheckboxItemProps> = ({
  ...props
}) => <StyledMenuCheckboxItem cursor="pointer" {...props} />;
